import { render, staticRenderFns } from "./InvoicesEdit.vue?vue&type=template&id=18819158"
import script from "./InvoicesEdit.vue?vue&type=script&lang=js"
export * from "./InvoicesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports